/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignInterviewSettingsShowPathParams,
	CampaignInterviewSettingsShowResponse,
} from '../types/CampaignInterviewSettingsShow'

/**
 * GET /interview-scheduling/campaigns/:campaign/interview-settings
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/CampaignInterviewSettingsController.php CampaignInterviewSettingsController::show
 */
export async function campaignInterviewSettingsShow(
	campaign: CampaignInterviewSettingsShowPathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignInterviewSettingsShowResponse>> {
	return axiosInstance.get(`/interview-scheduling/campaigns/${campaign}/interview-settings`, config)
}
